import { translateWithoutContext } from "@redux/modules/value/translations/translations.helpers";

export const splitPrice = (price: any, fractionDigits = 2) =>
    price.toFixed(fractionDigits).toString().split(".");

export function formatPrice(
    price?: number | null,
    canBeLabeledAsFree: boolean = false,
    addCurrency: boolean = false,
) {
    if (canBeLabeledAsFree && price === 0) {
        return translateWithoutContext("general.product.free");
    }

    return `${addCurrency ? "€" : ""}${(price || 0)
        .toFixed(2)
        .toString()
        .replace(".", ",")}`;
}

export function formatPriceNoRounding(price = 0, fractionDigits = 2) {
    return (
        parseInt("" + price * Math.pow(10, fractionDigits)) /
        Math.pow(10, fractionDigits)
    ).toFixed(fractionDigits);
}
